import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { useAuth } from './auth/AuthContext'

export const ProtectedRoute = ({component: Components, ...rest}) => {

  const { user, loading } = useAuth()
  return (
        <Route {...rest} render={props => {
            if (loading) {
              return null
            }
            if(user) {
              return <Components {...props} />;
            } else {
              return (
                <Redirect from={`${props.location}`} to='/login'/>
              );
            }
        }}
      />
    )
}

